import { createSlice } from '@reduxjs/toolkit';
import { resetAll } from '../resetState.action';
import { RootState } from '../store';

interface AppConfig {
    socials?: ClientAppConfigSocials;
    faq?: FAQ[];
    pricing?: ClientAppConfigPricing;
    legal?: ClientAppConfigLegal;
    messages?: ClientAppConfigMessages;
}

const initialState: AppConfig = {
    socials: undefined,
    faq: undefined,
    pricing: undefined,
    legal: undefined,
    messages: undefined,
};

// currently not being used
const AppConfigSlice = createSlice({
    name: 'appConfig',
    initialState,
    reducers: {
        set: (_, action) => {
            return action.payload;
        },
    },
    extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
});

// selectors
export const getAppConfigPicing = (state: RootState) => state.appConfig.pricing;
export const getAppConfig = (state: RootState) => state.appConfig;

// actions & reducer
export const { actions, reducer } = AppConfigSlice;
